module.exports = __webpack_public_path__ + "static/media/eco_values.ee7c6e3d.png";